<template>
  <div class="auth-wrapper">
    <section class="section">
      <h1 class="is-size-4 has-text-grey">
        {{ $t('Секунду... Выходим') }}
        <span class="loader auth-wrapper-loader"></span>
      </h1>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  async created () {
    try {
      await this.logout()
    } catch (e) {
      // console.log(e)
    }
    window.location.replace(`${__config.services.id}/login/?logout=true`)
  },
  methods: {
    ...mapActions('authentication', ['logout'])
  }
}
</script>
